import { Badge, Card, Group, Skeleton, Stack, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { Link } from "@tanstack/react-router";
import { useApiQuery } from "@/hooks/useApiQuery";
import { fetchServerLogSummary } from "./server-log.api";
import { fill } from "./server-log.logic";
import { useServerLogText } from "./use-server-log-text";

const SUMMARY_REFRESH_STALE_MS = 30_000;

/** Kartu "Error 24 jam" untuk halaman System Health (admin). */
export function ServerLogSummaryCard() {
	const t = useServerLogText();
	const { data, isLoading, isError } = useApiQuery(
		["server-log", "summary"],
		fetchServerLogSummary,
		{ autoRefresh: true, staleTime: SUMMARY_REFRESH_STALE_MS },
	);

	return (
		<Card withBorder p="lg" radius="md" mb="xl">
			<Group justify="space-between" mb="sm">
				<Group gap="xs">
					<IconAlertTriangle size={18} />
					<Text fw={600}>{t.card.title}</Text>
				</Group>
				<Text
					component={Link}
					to="/admin/server-log"
					size="sm"
					c="blue"
					td="underline"
				>
					{t.card.open}
				</Text>
			</Group>
			{isLoading && <Skeleton h={48} />}
			{isError && (
				<Text size="sm" c="dimmed">
					{t.card.failed}
				</Text>
			)}
			{data && (
				<Stack gap="xs">
					<Group gap="sm">
						<Badge
							color={data.errorGroups > 0 ? "red" : "green"}
							variant="light"
						>
							{fill(t.card.errors, { n: data.errorGroups })}
						</Badge>
						<Badge
							color={data.warnGroups > 0 ? "yellow" : "gray"}
							variant="light"
						>
							{fill(t.card.warns, { n: data.warnGroups })}
						</Badge>
					</Group>
					{data.errorGroups + data.warnGroups === 0 ? (
						<Text size="sm" c="dimmed">
							{fill(t.card.none, { h: data.hours })}
						</Text>
					) : (
						<Stack gap={2}>
							<Text size="xs" c="dimmed">
								{t.card.top}
							</Text>
							{data.top.map((g) => (
								<Text key={g.id} size="sm" lineClamp={1}>
									<b>{g.count}×</b> [{g.module}] {g.title}
								</Text>
							))}
						</Stack>
					)}
				</Stack>
			)}
		</Card>
	);
}
